import React, { useState, useEffect } from 'react';
import Layout from './components/Layout';
import { useNavigate, useParams } from 'react-router-dom';
import { getSpecifySchedule, getAccount, addMemberToSchedule, updateAccountPresenze, addPallini, addPalliniPremium } from './supabase';
import bullet from './icon/bullet.png'
import ak from './icon/ak.png'
import mil from './icon/mil.jpg'
function InfoCard() {
    const { activityId } = useParams()
    const navigation = useNavigate()
    const nome = localStorage.getItem('nome')
    const mail = localStorage.getItem('mail')
    const presenze = localStorage.getItem('presenze')
    const isAdmin = localStorage.getItem('admin') === 'true' // Add this line to check admin status
    const [data, setData] = useState([]) // Initialize as empty array instead of empty object
    const [loading, setLoading] = useState(true) // Add loading state
    const today = new Date()
    const formatToday = today.toISOString().split('T')[0]
    const getActivity = async () => {
        try {
            setLoading(true)
            const result = await getSpecifySchedule(activityId)
            // Make sure we're setting an array
            setData(Array.isArray(result) ? result : [result])
            console.log("Activity data:", result)
        } catch (error) {
            console.error("Error fetching activity:", error)
            setData([])
        } finally {
            setLoading(false)
        }
    }

  const [openModalPallini, setOpenModalPallini] = useState(false)
  
    const addPallinibutton = async (id, nome, members) => {
        if (!nome || nome === '' || nome === undefined || nome === null) {
            alert('Effettua di nuovo il login')
            navigation('/')
            return
        }
        console.log({id, nome, members})
        if (!members?.includes(nome)) {
            const allMembers = [...members, nome]
            await addPallini(id, allMembers)
            getActivity()
            alert('Prenotazione pallini effettuata')
        } else {
            const removeMember = members.filter(m => m !== nome)
            await addPallini(id, removeMember)
            getActivity()
            alert('Prenotazione pallini cancellata')
        }

    }

    const addMember = async (id, nome, members) => {
        if (!nome || nome === '' || nome === undefined || nome === null) {
            alert('Effettua di nuovo il login')
            navigation('/')
            return
        }

        if (!members?.includes(nome)) {
            const allMembers = [...members, nome]
            await addMemberToSchedule(id, allMembers)
            const newPresenze = parseInt(presenze) + 1
            await localStorage.setItem('presenze', newPresenze)
            await updateAccountPresenze(mail, newPresenze)
            getActivity()
            alert('Prenotazione effettuata')
        } else {
            // const removeMember = members.filter(m => m !== nome)
            // await addMemberToSchedule(id, removeMember)
            // const newPresenze = parseInt(presenze) - 1
            // await localStorage.setItem('presenze', newPresenze)
            // await updateAccountPresenze(mail, newPresenze)
            // getActivity()
            alert('Per cancellare la prenotazione contatta il direttivo')
        }
    }


    useEffect(() => {
        getActivity()
    }, [activityId])

    const removeMember = async (id, memberToRemove, members) => {
        if (!isAdmin) {
            alert('Solo gli admin possono rimuovere i membri')
            return
        }

        try {
            const updatedMembers = members.filter(m => m !== memberToRemove)
            await addMemberToSchedule(id, updatedMembers)
            getActivity()
            alert(`${memberToRemove} rimosso con successo`)
        } catch (error) {
            console.error('Error removing member:', error)
            alert('Errore durante la rimozione del membro')
        }
    }

    const removePallini = async (id, palliniToRemove, pallini) => {
        if (!isAdmin) {
            alert('Solo gli admin possono rimuovere i pallini')
            return
        }

        try {
            const updatedPallini = pallini.filter(p => p !== palliniToRemove)
            await addPallini(id, updatedPallini)
            getActivity()
            alert(`Prenotazione pallini di ${palliniToRemove} rimossa con successo`)
        } catch (error) {
            console.error('Error removing pallini:', error)
            alert('Errore durante la rimozione della prenotazione pallini')
        }
    }

    const addPalliniPremiumButton = async (id, nome, members) => {
        if (!nome || nome === '' || nome === undefined || nome === null) {
            alert('Effettua di nuovo il login')
            navigation('/')
            return
        }
        
        console.log({id, nome, members})
        if (!members?.includes(nome)) {
            const allMembers = members ? [...members, nome] : [nome]
            await addPalliniPremium(id, allMembers)
            getActivity()
            alert('Prenotazione pallini premium effettuata')
        } else {
            const removeMember = members.filter(m => m !== nome)
            await addPalliniPremium(id, removeMember)
            getActivity()
            alert('Prenotazione pallini premium cancellata')
        }
    }


    const removePalliniPremium = async (id, palliniToRemove, pallini) => {
        if (!isAdmin) {
            alert('Solo gli admin possono rimuovere i pallini premium')
            return
        }

        try {
            const updatedPallini = pallini.filter(p => p !== palliniToRemove)
            await addPalliniPremium(id, updatedPallini)
            getActivity()
            alert(`Prenotazione pallini premium di ${palliniToRemove} rimossa con successo`)
        } catch (error) {
            console.error('Error removing pallini premium:', error)
            alert('Errore durante la rimozione della prenotazione pallini premium')
        }
    }

    return (
        <Layout>
            <div className='w-full h-16 mb-4 flex flex-row justify-between items-center border border-white rounded-3xl'>
                {/* add back button with arrow icon */}
                <div className='w-16 h-full aspect-square font-bold rounded-full text-white flex items-center justify-center' onClick={() => navigation(-1)}>
                    <svg xmlns="URL_ADDRESS.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                    </svg>
                </div> 
                <p className='text-base font-semibold'>Info giocata</p>
                <p className='w-16 aspect-square'></p>
            </div>


            <div className='bg-[#1E2021] w-full h-fit flex flex-col rounded-3xl p-4 mb-20'>
                {loading ? (
                    <div className="text-white text-center p-4">Caricamento...</div>
                ) : data.length > 0 ? (
                    data.map((a, index) => (
                        <div key={index} className="bg-[#1E2021] w-full h-fit flex flex-col rounded-3xl p-4 mb-4">
                            <div className='w-full flex justify-center flex-col items-center'>
                                <div className='bg-[#3B934E] flex w-fit rounded-full p-1 flex-row'>
                                    <h1 className='text-xs font-bold text-white'>{a?.type}</h1>
                                </div>
                                <p className='text-base text-white pt-2 text-center'>{a.title}</p>
                                <h1 className='text-3xl font-black text-white first-letter:uppercase'>
                                    {new Date(a.date).toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}
                                </h1>
                                <p className='text-lg text-white'>{a?.time?.slice(0, 5)} - {a?.end?.slice(0, 5)}</p>
                            </div>
                            {a.date === '2025-04-13' ? 
                        
                            <img src={mil} className='w-full h-auto mt-4 rounded-lg' /> : 
                            null
                            }
                            <div>
                                <h1 className='text-base text-[#FFFFFF70] text-start mt-1'>Appuntamento: <h1 className='text-base text-white'>{a.where} - {a?.appointment_hour?.slice(0, 5)}</h1></h1>
                                <h1 className='text-base text-[#FFFFFF70] mt-1'>Campo: <h1 className='text-base text-white'>{a.campo}</h1></h1>
                                <h1 className='text-base text-[#FFFFFF70] text-start mt-1'>Setup: <h1 className='text-base text-white'>{a.setup}</h1></h1>
                                <p className='text-base text-white'>{a?.info}</p>

                                <div className='flex flex-col w-full mt-2'>
                                    <div className='w-full flex justify-between flex-row'>    
                                <p className='text-base text-[#FFFFFF70] flex flex-row items-center h-4'> N° {a?.member?.length} Presenti:</p>
                                <img src={ak} className='w-auto h-4 mr-4' />
                                   </div>
                                    <div className='flex flex-row flex-wrap w-full mt-2'>
                                        {a?.member?.map((p, i) => (
                                            <div key={i} className='flex flex-row items-center'>
                                                <p className={`text-base text-white h-fit border border-white w-fit rounded-full p-1 m-1 pl-1 ${p === nome ? "bg-gradient-to-l from-[#83926280] to-[#839262]" : "" }`}>
                                                    {p}
                                                    {isAdmin && (
                                                        <button 
                                                            className='px-2 text-whyte hover:text-red-700'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                removeMember(a.id, p, a?.member);
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    )}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div> 
                                    <div className='flex flex-col w-full mt-2'>
                                    <div className='w-full flex justify-between flex-row'>  
                                    <p className='text-base text-[#FFFFFF70] flex flex-row items-center h-4'>Prenotazione pallini BASIC:</p>
                                    <img src={bullet} className='w-auto h-4 mr-4' />
                                    </div>
                                    <div className='flex flex-row flex-wrap w-full mt-2'>
                                        {a?.pallini?.map((p, i) => (
                                            <div key={i} className='flex flex-row items-center'>
                                                <p className='text-base text-white h-fit border border-white w-fit rounded-full p-1 m-1'>
                                                    {p}
                                                    {isAdmin && (
                                                        <button 
                                                            className='px-2 text-white hover:text-red-700'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                removePallini(a.id, p, a?.pallini);
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    )}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div> 
                                {a?.date >= formatToday && (
                                    <>
                                        <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full mt-4 w-full' 
                                            onClick={() => addPallinibutton(a.id, nome, a?.pallini)}>
                                            {a.pallini !== null && a?.pallini.includes(nome) ? 'Cancella prenotazione pallini basic' : 'Prenota pallini basic'}
                                        </button>
                                       
                                    </>
                                )}
                                <div> 
                                    <div className='flex flex-col w-full mt-2'>
                                    <div className='w-full flex justify-between flex-row'>  
                                    <p className='text-base text-[#FFFFFF70] flex flex-row items-center h-4'>Prenotazione pallini PREMIUM:</p>
                                    <img src={bullet} className='w-auto h-4 mr-4' />
                                    </div>
                                    <div className='flex flex-row flex-wrap w-full mt-2'>
                                        {a?.pallini_premium?.map((p, i) => (
                                            <div key={i} className='flex flex-row items-center'>
                                                <p className='text-base text-white h-fit border border-white w-fit rounded-full p-1 m-1'>
                                                    {p}
                                                    {isAdmin && (
                                                        <button 
                                                            className='px-2 text-white hover:text-red-700'
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                removePalliniPremium(a.id, p, a?.pallini_premium);
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    )}
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div> 
                                {a?.date >= formatToday && (
                                    <>
                                     
                                        <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full mt-2 w-full' 
                                            onClick={() => addPalliniPremiumButton(a.id, nome, a?.pallini_premium)}>
                                            {a.pallini_premium !== null && a?.pallini_premium.includes(nome) ? 'Cancella prenotazione pallini premium' : 'Prenota pallini premium'}
                                        </button>
                                    </>
                                )}
                                </div> 
                                 </div>
                                <p className='text-base text-white mt-4'>{a.desc}</p>
                                <p className='text-base text-white mt-10'><strong>ATTENZIONE:</strong> Si raccomanda puntualità e di non lasciare il campo prima del termine. Verificate regolarmente eventuali variazioni di orario o campo. La lista sarà chiusa venerdì alle 23:00. In caso di rinuncia, avvisate un membro del direttivo entro sabato sera tramite telefono o WhatsApp. Le assenze non giustificate dopo l'iscrizione saranno considerate gravi.</p>
                            </div>
                            {a?.date >= formatToday && ( <button className='bg-[#839262] font-bold py-2 px-4 rounded-full mt-4 text-white w-full mr-2 text' onClick={() => addMember(a.id, nome, a?.member)}>{a.member !== null && a?.member.includes(nome) ? 'Cancella prenotazione' : 'Prenotati'}</button>)}
                        </div>
                    ))
                ) : (
                    <div className="text-white text-center p-4">Nessuna attività trovata</div>
                )}
            </div>

        </Layout>
    );
};

export default InfoCard;
